import { AppImages } from '../utility/AppImages';
import { DEVICE_SIZES } from 'rn-responsive-styles';

// Belt/Medal Configuration
export const BELT_MEDAL_TYPES = [
  {
    id: 0,
    value: 0,
    image: AppImages.icCoinBelt,
    title: "Coin",
    locked: true,
    purchaseLock: true,
    dimensions: {
      [DEVICE_SIZES.XS]: { width: 69, height: 69 },
      [DEVICE_SIZES.SM]: { width: 69, height: 69 },
      default: { width: 77, height: 69 }
    },
    popupIconWidth: 58,
  },
  {
    id: 1,
    image: AppImages.icBronzeBelt,
    title: "Bronze",
    purchaseLock: false,
    dimensions: {
      default: { width: 99, height: 79 }
    },
    popupIconWidth: 73,
  },
  {
    id: 2,
    image: AppImages.icSilverBelt,
    title: "Silver",
    purchaseLock: true,
    dimensions: {
      default: { width: 99, height: 79 }
    },
    popupIconWidth: 73,
  },
  {
    id: 3,
    image: AppImages.icGoldBelt,
    title: "Gold",
    purchaseLock: true,
    dimensions: {
      default: { width: 99, height: 79 }
    },
    popupIconWidth: 73,
  },
  {
    id: 4,
    image: AppImages.icPlatinumBelt,
    title: "Platinum",
    purchaseLock: true,
    dimensions: {
      default: { width: 99, height: 79 }
    },
    popupIconWidth: 73,
  },
];

// Device-specific dimensions
export const NOTIFICATION_DIMENSIONS = {
  button: {
    height: {
      [DEVICE_SIZES.XS]: 17.5,
      [DEVICE_SIZES.SM]: 17.5,
      default: 35
    },
    padding: {
      [DEVICE_SIZES.XS]: { vertical: 0, horizontal: 8 },
      [DEVICE_SIZES.SM]: { vertical: 0, horizontal: 8 },
      default: { vertical: 10, horizontal: 14 }
    }
  },
  card: {
    padding: {
      [DEVICE_SIZES.XS]: { vertical: 8, horizontal: 8 },
      [DEVICE_SIZES.SM]: { vertical: 8, horizontal: 8 },
      default: { vertical: 12, horizontal: 24 }
    },
    margin: {
      [DEVICE_SIZES.XS]: { vertical: 8, horizontal: 8 },
      [DEVICE_SIZES.SM]: { vertical: 8, horizontal: 8 },
      default: { vertical: 12, horizontal: 40 }
    },
    gap: {
      [DEVICE_SIZES.XS]: 8,
      [DEVICE_SIZES.SM]: 8,
      default: 12
    }
  }
};

// Notification action mappings
export const REMINDER_HOURS_MAP = {
  'reminder-24h': 24,
  'reminder-12h': 12,
  'reminder-6h': 6,
  'reminder-3h': 3,
  'reminder-1h': 1,
  'final-warning': 1,
};

export const CHECK_IN_HOURS_MAP = {
  '24 hours check-in': 24,
  '12 hours check-in': 12,
  '6 hours check-in': 6,
  '5 hours check-in': 5,
  '3 hours check-in': 3,
  '2 hours check-in': 2,
  '1 hours check-in': 1,
  'half hour check-in': 0.5,
};

export const REMINDER_SEQUENCE = [24, 12, 6, 3, 1, 0];
export const CHECK_IN_SEQUENCE = [24, 12, 6, 5, 3, 2, 1, 0.5, 0];

// Background notification types that don't increment count
export const BACKGROUND_NOTIFICATION_TYPES = [
  'event_status_update',
  'coins_reward',
  'user-registered',
];

// Notification keys mapping - replace hardcoded strings
export const REMINDER_KEYS = {
  REMINDER_24H: 'reminder-24h',
  REMINDER_12H: 'reminder-12h', 
  REMINDER_6H: 'reminder-6h',
  REMINDER_3H: 'reminder-3h',
  REMINDER_1H: 'reminder-1h',
  FINAL_WARNING: 'final-warning',
} as const;

export const CHECK_IN_KEYS = {
  HALF_HOUR: 'half hour check-in',
  ONE_HOUR: '1 hours check-in',
  TWO_HOURS: '2 hours check-in',
  THREE_HOURS: '3 hours check-in',
  FIVE_HOURS: '5 hours check-in',
  SIX_HOURS: '6 hours check-in',
  TWELVE_HOURS: '12 hours check-in',
  TWENTY_FOUR_HOURS: '24 hours check-in',
} as const;

export const EVENT_REMINDER_KEYS = {
  ONE_HOUR: '1 hours event-reminder',
  TWO_HOURS: '2 hours event-reminder',
  THREE_HOURS: '3 hours event-reminder',
  FOUR_HOURS: '4 hours event-reminder',
  FIVE_HOURS: '5 hours event-reminder',
  SIX_HOURS: '6 hours event-reminder',
  TWELVE_HOURS: '12 hours event-reminder',
  TWENTY_FOUR_HOURS: '24 hours event-reminder',
} as const;

export const ACTION_TYPES = {
  CHECK_IN: 'check-in',
  ATTENDANCE_REMINDER: 'attendance-reminder',
  CHALLENGER_CHECK_IN: 'challenger_check_in',
  ORGANISER_CHECK_IN: 'organiser_check_in',
  EVENT_REMINDER: 'event-reminder',
  EVENT_UPDATE_STATUS: 'event_update_status',
  EVENT_UPDATE: 'event_update',
  EVENT_UPDATE_BEFORE: 'event_update_before',
  ATTENDANCE_MISSED: 'attendance-missed',
  OPPONENT_ALERT: 'opponent-alert',
  ACCOUNT_WARNING: 'account-warning',
  CHALLENGE_REQUEST: 'challenge_request',
  EVENT_AWARDED: 'event-awarded',
  EVENT_LOST: 'event-lost',
  CHALLENGE_RESPONSE: 'challenge_response',
  ACCEPT_REJECT: 'accept_reject',
  CHECK_IN_MISSED: 'check-in-missed',
  AUDIENCE_ALERT: 'audience-alert',
} as const;

export const ACTION_STATUS = {
  PENDING: 'pending',
  CONFIRMED: 'confirmed',
  ACCEPTED: 'accepted',
  REJECTED: 'rejected',
  SEND: 'send',
} as const;

export const CATEGORY_STATUS = {
  CANCELLED: 'cancelled',
  COMPLETED: 'completed',
} as const;

// Magic numbers - replace hardcoded values
export const NOTIFICATION_VALUES = {
  SIGNUP_NUMBER: 70,
  BORDER_RADIUS: 12,
  BORDER_WIDTH: 1,
  Z_INDEX: 1,
} as const;

// Storage keys
export const STORAGE_KEYS = {
  UNREAD_CHALLENGE: 'challengerUnreadCount',
  NOTIFICATION_COUNT: 'challengeNotificationCount',
  CHAT_NOTIFICATION_COUNT: 'chatNotificationCount',
};

// API pagination limits
export const PAGINATION_LIMITS = {
  INITIAL_LOAD: 40,
  LOAD_MORE: 20,
};
